/** Public navbar “Download data” dropdown items. */
export const RECOVERY_DATA_DOWNLOAD_PRICE_RUPEES = 29;

export const RECOVERY_DATA_DOWNLOADS = [
  {
    id: "yards",
    label: "All India Yard Details",
    kind: "yards",
    filename: "All-India-Yard-Details.xlsx",
    priceRupees: RECOVERY_DATA_DOWNLOAD_PRICE_RUPEES,
  },
  {
    id: "agencies",
    label: "All India Repo/Collection Agencies Details",
    kind: "repo-agencies",
    filename: "All-India-Repo-Collection-Agencies-Details.xlsx",
    priceRupees: RECOVERY_DATA_DOWNLOAD_PRICE_RUPEES,
  },
  {
    id: "cranes",
    label: "All India Crane/Towing Service Details",
    kind: "crane-services",
    filename: "All-India-Crane-Towing-Service-Details.xlsx",
    priceRupees: RECOVERY_DATA_DOWNLOAD_PRICE_RUPEES,
  },
];
